// Shared design tokens for the partners dashboard
// Centralises borders, shadows, and contrast colours so every component is consistent.
// ALL dark-mode values are neutral slate/charcoal — zero green tint.

export const tokens = {
    // ── Borders ──────────────────────────────────────────
    border: {
        glass: (isDark: boolean) =>
            `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
        card: (isDark: boolean) =>
            `1px solid ${isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"}`,
        divider: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)",
    },

    // ── Shadows ──────────────────────────────────────────
    shadow: {
        glass: "0 4px 24px rgba(0,0,0,0.15)",
        glassHover: "0 8px 32px rgba(0,0,0,0.22)",
        card: (isDark: boolean) =>
            isDark
                ? "0 2px 12px rgba(0,0,0,0.4)"
                : "0 2px 12px rgba(0,0,0,0.06)",
    },

    // ── Text colours (4.5:1 contrast ratio guaranteed) ───
    text: {
        primary: (isDark: boolean) => (isDark ? "#E8E8ED" : "#1D1D1F"),
        secondary: (isDark: boolean) => (isDark ? "#8E8E93" : "#6E6E73"),
        muted: (isDark: boolean) => (isDark ? "#636366" : "#86868B"),
    },

    // ── Surface colours (neutral slate/charcoal) ────────
    surface: {
        glass: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.55)",
        glassHover: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.70)",
        card: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.85)",
        overlay: (isDark: boolean) =>
            isDark ? "rgba(15,17,23,0.7)" : "rgba(255,255,255,0.6)",
        // Elevated surface for modals, dropdowns
        elevated: (isDark: boolean) =>
            isDark ? "#1A1D27" : "#FFFFFF",
    },

    // ── Background base colours ──────────────────────────
    bg: {
        page: (isDark: boolean) => (isDark ? "#0F1117" : "#FFFFFF"),
        sidebar: (isDark: boolean) => (isDark ? "#13151D" : "#FFFFFF"),
        tableHeader: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.03)" : "#F8FAFC",
        tableRow: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.02)" : "transparent",
        input: (isDark: boolean) =>
            isDark ? "rgba(255,255,255,0.05)" : "inherit",
    },

    // ── Radii ────────────────────────────────────────────
    radius: {
        sm: 8,
        md: 16,
        lg: 24,
        pill: 999,
    },
} as const;
